import { enterpriseImageRecordTarget, isEnterpriseImageRecord } from '~/utils/enterpriseImage'

/** 新图片与旧图转 PDF 分流；文件名只在鉴权后的查看页读取。 */
export function useEnterpriseImageNavigation() {
  const localePath = useLocalePath()
  return (record: any): boolean => {
    const target = enterpriseImageRecordTarget(record)
    if (!target) return isEnterpriseImageRecord(record)
    const link = document.createElement('a')
    link.href = localePath(target); link.target = '_blank'; link.rel = 'noopener noreferrer'
    document.body.appendChild(link); link.click(); link.remove()
    return true
  }
}
